import { render } from "./ListShopLinks.vue?vue&type=template&id=3873dd24"
import script from "./ListShopLinks.vue?vue&type=script&lang=js"
export * from "./ListShopLinks.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__